import { inject, Injectable } from "@angular/core";
import {
    catchError,
    Observable,
    of,
    Subject,
    switchMap
} from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { FileBase64 } from "~app/common/components/file-upload/file-upload.component";
import { ApiClientService } from "~app/common/services/api-client.service";
import { GenericFeatureInfo, ImportGeometriesRequestDto } from "~app/features/virkeskop/karta/import-geometries-popup/import-geometries-models";
import { KontraktMediatorService } from "~app/features/virkeskop/services/kontrakt-mediator.service";

@Injectable()

export class MapImportService {
    readonly fileImport$: Observable<GenericFeatureInfo[]>;
    readonly closeFileImport$ = new Subject<void>();

    private readonly apiClientService = inject(ApiClientService);
    private readonly fileImportSrc = new Subject<FileBase64>();
    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly busyService = inject(BusyService);

    constructor() {
        this.fileImport$ = this.fileImportSrc.pipe(
            switchMap(f => this.mapFile(f)),
            switchMap(req => this.importGeometries(req).pipe(
                catchError(() => of([]))
            ))
        );
    }

    processFile(file: FileBase64) {
        this.fileImportSrc.next(file);
    }

    closeFileImport(): void {
        this.closeFileImport$.next();
    }

    private importGeometries(request: ImportGeometriesRequestDto): Observable<GenericFeatureInfo[]> {
        const work = this.apiClientService.post<ImportGeometriesRequestDto, GenericFeatureInfo[]>("geometri/import", request);
        return this.busyService.addWork(work);
    }

    private readonly mapFile = (file: FileBase64): Observable<ImportGeometriesRequestDto> =>
        of({
            file: file.content,
            fileName: file.name,
            kontraktId: this.kontraktMediatorService.kontrakt.id
        });
}
